import { FC } from 'react';

// material-ui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import Avatar from '@/components/@extended/Avatar';
import { PopupTransition } from '@/components/@extended/Transitions';

// assets
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';

// ==============================|| AUTH - MODALĂ SESIUNE EXPIRATĂ ||============================== //
// Se afișează când sesiunea a expirat (user inactiv / refresh eșuat / 401 în zbor), în locul
// unei erori brute. Nu se poate închide — singura ieșire e re-autentificarea (CTA).

interface Props {
	open: boolean;
	onReLogin: () => void;
}

export const SessionExpiredModal: FC<Props> = ({ open, onReLogin }) => (
	<Dialog
		open={open}
		keepMounted
		fullWidth
		maxWidth="xs"
		slots={{ transition: PopupTransition }}
		aria-labelledby="session-expired-title"
	>
		<DialogContent sx={{ p: 3 }}>
			<Stack sx={{ gap: 2.5, alignItems: 'center' }}>
				<Avatar color="warning" sx={{ width: 64, height: 64, fontSize: '1.5rem' }}>
					<ClockCircleOutlined />
				</Avatar>
				<Stack sx={{ gap: 1 }}>
					<Typography
						variant="h4"
						sx={{ textAlign: 'center' }}
						id="session-expired-title"
					>
						Sesiune expirată
					</Typography>
					<Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>
						Sesiunea ta a expirat din cauza inactivității. Pentru a continua, te rugăm să
						te autentifici din nou.
					</Typography>
				</Stack>
				<Button fullWidth variant="contained" onClick={onReLogin} autoFocus>
					Autentifică-te din nou
				</Button>
			</Stack>
		</DialogContent>
	</Dialog>
);
